import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { Field, reduxForm, formValueSelector, change } from 'redux-form'

import ReactModal from 'react-modal'
import { translate } from 'react-i18next'
import { required } from 'utils/validation'
import { makeGetDefaultAccount, makeGetToken } from 'lib/selector'
import { handleApiErrors } from 'lib/api-errors'
import { setToast } from 'containers/client/actions'

import { ReactComponent as IconCloseFilter } from 'assets/img/icon/ic_close_filter.svg'

import styled from 'styled-components'
import { mapFormulaID } from 'utils/config'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ImInfo } from 'react-icons/im'
import RenderInputOrder from './layout/renderInput'
import renderSelect from './layout/renderSelect'
import renderMultiSelect from './layout/renderMultiSelect'
import RenderFieldCheckbox from 'components/input/renderCheckboxFilter'
import * as _ from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { arrMCStock } from 'utils/config'
import { arrAvgVolStock } from 'utils/config'

const apiUrl = `${process.env.REACT_APP_ALGO_API_URL}`

//#region
const customStyles = {
  content: {
    top: '40px',
    left: '50%',
    width: '556px',
    transform: 'translate(-50%)',
    bottom: 'auto',
    backgroundColor: 'var(--bg-th-even)',
    border: 'none',
    boxShadow: '0px 0px 3px rgba(160, 160, 160, 0.25)',
  },
}

const StyleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  background: ${(props) => (props.theme === 'dark' ? '#1c192c' : '#ffffff')};
  border-radius: 8px;
`

const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: var(--half_white);
  font-weight: 500;
  font-size: 16px;
  padding: 16.5px 24px;
  border: 1px solid #4e4d62;
  border-width: 0 0 1px 0;
`

const StyleBody = styled.div`
  padding: 0 24px;

  form {
    display: flex;
    flex-direction: column;

    label {
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: var(--half_white);
      align-self: center;

      &.sub-label {
        color: #d7d6d9;
        padding-left: 16px;
      }

      .check_mark {
        top: -8px;
      }
    }

    select {
      width: 100%;
    }

    .form-control {
      border: 1px solid #4e4d62;
      border-radius: 3px;
      padding: 8px 16px;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: var(--half_white);
      background: transparent;
      padding: 8px 12px;
    }
  }
`

const GroupContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 300px;
  gap: 16px 10px;
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #312f43;
`

const StyleBtn = styled.button`
  padding: 8px 16px;
  height: 32px;
  border-radius: 3px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 125px;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    color: #f0b90b;
    border-color: #f0b90b;
    background: #878379;
  }
`

const StyleBtnOutline = styled(StyleBtn)`
  color: #f0b90b;
  border: 1px solid #f0b90b;
  background: transparent;
`

const StyleBtnSubmit = styled(StyleBtn)`
  color: #27272d;
  border: 1px solid #f0b90b;
  background: #f0b90b;

  &:disabled{
    background: #818181;
    border-color: #818181;
  }
`
//#endregion

function usePrevious(value) {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

function DatCanhBao(props) {
  const abortController = new AbortController()
  const dispatch = useDispatch()
  const {
    token,
    onClose,
    t,
    theme,
    signalName,
    signalType,
    signalIsCapital,
    signalIsAvgVol5day,
  } = props

  const [optFolio, setOptFolio] = React.useState([])

  React.useEffect(() => {
    return () => {
      abortController.abort()
    }
  }, [])

  function submit(values) {
    //   signalName,
    //   criteriaSignal,
    //   signalType,
    //   signalTypeSymbol,
    //   signalTypeFolio,
    //   signalTypeIndex,
    //   signalCapital,
    //   signalIsCapital,
    //   signalIsAvgVol5day,
    //   signalAvgVol5day,

    const params = {
      userID: token?.user,
      signalName: values?.signalName, // tên bộ lọc tín hiệu
      realtimeFormulaID: values?.criteriaSignal,
      groupSecType:
        signalType === 'SYMBOL' ? 1 : signalType === 'PORTFOLIO' ? 2 : 3,
      groupSecName:
        signalType === 'PORTFOLIO'
          ? values?.signalTypeFolio
          : signalType === 'INDEX'
          ? values?.signalTypeIndex
          : null,
      secList:
        signalType === 'SYMBOL'
          ? values?.signalTypeSymbol
          : null,
      mcFilter: values?.signalIsCapital ? values.signalCapital : 0,
      volFilter: values?.signalIsAvgVol5day ? values.signalAvgVol5day : 0,
      active: 1,
    }

    fetch(apiUrl + 'pbapi/api/usersignals/' + token?.user, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(params),
      signal: abortController.signal,
    })
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.status === 200) {
          // setAllTier(json.data)
          _handleToast('Đăng ký tín hiệu thành công', 'success')
          onClose()
        } else {
          _handleToast(json.message, 'error')
        }
      })
      .catch((error) => {
        throw error
      })
  }

  function _handleToast(msg, type = 'info') {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
      type,
    }
    dispatch(setToast(toastMsg))
  }

  const { handleSubmit, submitting, criteriaSignal } = props

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      //   shouldCloseOnOverlayClick={true}
      style={customStyles}
    >
      <StyleContainer theme={theme}>
        <StyleHeader>
          {t('algo.cb.txt-Set-signals')}
          <a className="ml-auto" onClick={onClose}>
            <IconCloseFilter />
          </a>
        </StyleHeader>
        <StyleBody>
          <form onSubmit={handleSubmit(submit)}>
            <PerfectScrollbar style={{ maxHeight: 'calc(100vh - 215px)' }}>
              <GroupContent>
                <label>Đặt tên tín hiệu:</label>
                <Field
                  name="signalName"
                  className="form-control"
                  placeholder="Nhập tên tín hiệu"
                  component={RenderInputOrder}
                  validate={[required]}
                />
              </GroupContent>
              <GroupContent>
                <label>
                  Loại tín hiệu{' '}
                  {criteriaSignal && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          {t('algo.tooltip.' + criteriaSignal)}
                        </Tooltip>
                      }
                    >
                      <ImInfo className="ml-2 fz-12 txt-content" />
                    </OverlayTrigger>
                  )}
                </label>
                <Field
                  name="criteriaSignal"
                  validate={[required]}
                  component={renderSelect}
                  isActive={true}
                  arrOpt={Object.entries(mapFormulaID).map(([key]) => ({
                    value: key,
                    label: t('algo.signal.' + key),
                  }))}
                />
              </GroupContent>
              <GroupContent>
                <label style={{ gridColumn: '1/3' }}>Cài đặt cho:</label>
                <label className="sub-label">
                  <Field
                    name="signalType"
                    component="input"
                    type="radio"
                    value="SYMBOL"
                  />{' '}
                  Mã chứng khoán
                </label>
                <Field
                  name="signalTypeSymbol"
                  validate={signalType === 'SYMBOL' ? required : null}
                  isActive={signalType === 'SYMBOL'}
                  component={renderMultiSelect}
                />
                <label className="sub-label">
                  <Field
                    name="signalType"
                    component="input"
                    type="radio"
                    value="PORTFOLIO"
                  />{' '}
                  Danh mục
                </label>
                <Field
                  name="signalTypeFolio"
                  validate={signalType === 'PORTFOLIO' ? required : null}
                  isActive={signalType === 'PORTFOLIO'}
                  component={renderSelect}
                  arrOpt={optFolio}
                />
                <label className="sub-label">
                  <Field
                    name="signalType"
                    component="input"
                    type="radio"
                    value="INDEX"
                  />{' '}
                  Sàn
                </label>
                <Field
                  name="signalTypeIndex"
                  validate={signalType === 'INDEX' ? required : null}
                  isActive={signalType === 'INDEX'}
                  component={renderSelect}
                  arrOpt={[
                    { value: 'HOSE', label: 'HOSE' },
                    { value: 'HNX', label: 'HNX' },
                    { value: 'UPCOM', label: 'UPCOM' },
                  ]}
                />
              </GroupContent>
              <GroupContent>
                <label style={{ gridColumn: '1/3' }}>Điều kiện:</label>
                <label className="sub-label d-flex">
                  <Field
                    name="signalIsCapital"
                    id="signalIsCapital"
                    component={RenderFieldCheckbox}
                  />
                  Vốn hóa
                </label>
                <Field
                  name="signalCapital"
                  validate={signalIsCapital ? required : null}
                  isActive={signalIsCapital}
                  component={renderSelect}
                  arrOpt={arrMCStock}
                />
                <label className="sub-label d-flex">
                  <Field
                    name="signalIsAvgVol5day"
                    id="signalIsAvgVol5day"
                    component={RenderFieldCheckbox}
                  />
                  TB KLGD 5 phiên
                </label>
                <Field
                  name="signalAvgVol5day"
                  validate={signalIsAvgVol5day ? required : null}
                  isActive={signalIsAvgVol5day}
                  component={renderSelect}
                  arrOpt={arrAvgVolStock}
                />
              </GroupContent>
            </PerfectScrollbar>
            <div className="d-flex justify-content-end my-3">
              <StyleBtnOutline
                type="button"
                disabled={submitting}
                onClick={onClose}
              >
                {t('algo.cb.txt-Cancel')}
              </StyleBtnOutline>
              <StyleBtnSubmit
                type="submit"
                disabled={submitting || !signalType || !signalName}
                className="ml-2"
              >
                Lưu
              </StyleBtnSubmit>
            </div>
          </form>
        </StyleBody>
      </StyleContainer>
    </ReactModal>
  )
}

DatCanhBao = reduxForm({
  form: 'datcanhbaoform',
  enableReinitialize: true,
})(DatCanhBao)

const selector = formValueSelector('datcanhbaoform')

const makeMapStateToProps = () => {
  const getToken = makeGetToken()
  const getDefaultAccount = makeGetDefaultAccount()

  const mapStateToProps = (state) => {
    const {
      signalName,
      criteriaSignal,
      signalType,
      signalTypeSymbol,
      signalTypeFolio,
      signalTypeIndex,
      signalCapital,
      signalIsCapital,
      signalIsAvgVol5day,
      signalAvgVol5day,
    } = selector(
      state,
      'signalName',
      'criteriaSignal',
      'signalType',
      'signalTypeSymbol',
      'signalTypeFolio',
      'signalTypeIndex',
      'signalIsCapital',
      'signalCapital',
      'signalIsAvgVol5day',
      'signalAvgVol5day'
    )

    const defAccount = getDefaultAccount(state)

    return {
      token: getToken(state),
      defAccount,

      signalName,
      criteriaSignal,
      signalType,
      signalTypeSymbol,
      signalTypeFolio,
      signalTypeIndex,
      signalCapital,
      signalIsCapital,
      signalIsAvgVol5day,
      signalAvgVol5day,
      initialValues: {
        signalName: '',
        criteriaSignal: '1143',
        signalType: 'PORTFOLIO',
        signalTypeIndex: 'HOSE',
        signalCapital: '500',
        signalIsCapital: false,
        signalIsAvgVol5day: false,
        signalAvgVol5day: '10000',
      },
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(
  translate('translations')(DatCanhBao)
)
